/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { task } from "ember-concurrency";
import type Patient from "parog-web/models/patient";
import type PatientChatMessageSentJournalEvent from "parog-web/models/patient-chat-message-sent-journal-event";
import fetchChatMessageJes from "../utils/fetch-chat-messages";

interface Args {
  patient: Patient;
  scrollAndFocus: () => void;
}

export default class ChatMessageFeed extends Component<Args> {
  @service declare store: Store;

  @tracked private currentLoadedPage = 1;
  @tracked private totalPageCount?: number;
  private pageSize = 50;

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.currentLoadedPage =
      Math.floor(
        this.args.patient.patientChatMessageSentJournalEvents.length /
          this.pageSize
      ) || 1;
    this.fetchChatMessageJesAndScrollTask.perform();
  }

  fetchChatMessageJesTask = task(async () => this.fetchChatMessages());
  fetchChatMessageJesAndScrollTask = task(async () => {
    await this.fetchChatMessages();
    this.args.scrollAndFocus();
  });

  private async fetchChatMessages() {
    const res = await fetchChatMessageJes(
      this.store,
      this.args.patient,
      this.currentLoadedPage,
      this.pageSize
    );

    this.currentLoadedPage++;
    this.totalPageCount = res.pageCount;
  }

  get hasMoreMessageToLoad(): boolean {
    return (
      Boolean(this.totalPageCount) &&
      this.currentLoadedPage <= this.totalPageCount!
    );
  }

  get messages(): PatientChatMessageSentJournalEvent[] {
    return this.args.patient.patientChatMessageSentJournalEvents.slice();
  }
}
